module.exports = __webpack_public_path__ + "img/be-clear.8051a11c.png";